<template>
  <div class="hp-base-panel-wrp">
    <div class="evalute-panel hp-base-panel">
      <p class="title">咨询评价</p>
      <template v-for="(item, index) in rateList">
        <EvaluateItem
          :key="item.id"
          :info="item"
          tab="homepageServiceTab"
        ></EvaluateItem>
        <van-divider
          v-if="index !== rateList.length - 1"
          :key="item.id"
          :style="{ margin: '0.2rem 0' }"
        />
      </template>

      <p v-if="showMore" class="more" @click="toRateTab">
        查看更多评价
        <van-icon name="arrow" />
      </p>
    </div>
  </div>
</template>

<script>
import { Icon as VanIcon, Divider as VanDivider } from 'vant'
import EvaluateItem from 'component/platform/homepage/normalUser/evaluateItem.vue'

export default {
  components: {
    EvaluateItem,
    VanIcon,
    VanDivider
  },
  computed: {
    rateList() {
      return this.$store.state.homepage.serviceTabRateList.slice(0, 3)
    },
    showMore() {
      return this.$store.state.homepage.serviceTabRateList.length > 3
    }
  },
  methods: {
    toRateTab() {
      this.$trackEvent('newprofilepages_consulttab_more', {})
      this.$store.commit('homepage/SET_COMMON_RATE_TYPE', 'consult')
      this.$emit('toRateTab')
    }
  }
}
</script>

<style lang="scss" scoped>
.evalute-panel {
  padding: 30px;
  position: relative;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #21252d;
    margin-bottom: 20px;
  }
  .evaluate-item {
    padding: 10px 0;
    box-shadow: none;
    border-radius: 0;
    margin-bottom: 0;
  }
  .more {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #6982fa;
    text-align: center;
    line-height: 50px;
    margin-top: 15px;
    i {
      line-height: 50px;
      vertical-align: top;
    }
  }
}
</style>
